import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { TdLoadingService } from '@covalent/core';
import { AdminService } from '../../../../../../services/admin/admin.service';
import { PetitionCategory } from '../../../../../../shared/admin-models/interfaces/petition-category.interface';

@Component({
  selector: 'app-add-edit-category-dialog',
  templateUrl: './add-edit-category-dialog.component.html',
  styleUrls: ['./add-edit-category-dialog.component.scss']
})
export class AddEditCategoryDialogComponent implements OnInit {
  dialogTitle: string;
  category: PetitionCategory = {
    title: '',
    description: '',
    imageFileId: ''
  };
  fileId: string;
  file: File;
  fileUploadProgress: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AddEditCategoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string; mode: string },
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.dialogTitle =
      this.data && this.data.mode === 'add'
        ? 'კატეგორიის დამატება'
        : 'კატეგორიის რედაქტირება';
    (this.data);
    if (this.data && this.data.id && this.data.mode === 'edit') {
      this.getCategory();
    }
  }
  getCategory() {
    this._loadingService.register();
    this._adminService.getCategory(this.data.id).subscribe(
      (res: PetitionCategory) => {
        this._loadingService.resolve();
        this.category = res;
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  closeDialog() {
    this.dialogRef.close();
  }
  uploadFile(e) {
    this.fileUploadProgress = true;
    this.file = e.target.files[0];
    const fileReqData = new FormData();
    fileReqData.append('file', this.file);
    this._adminService.uploadFile(fileReqData).subscribe(
      (res) => {
        this.fileUploadProgress = false;
        this.category.imageFileId = res._id;
      },
      (err) => {
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  openFile(): void {
    if (this.category.imageFileId) {
      this._adminService.openFilePdf(this.category.imageFileId);
    }
  }
  send() {
    if (this.data && this.data.id && this.data.mode === 'edit') {
      this.editCategory();
    } else {
      this.addCategory();
    }
  }
  addCategory() {
    this._loadingService.register();
    this._adminService.addCategory(this.category).subscribe(
      (res: PetitionCategory) => {
        this._loadingService.resolve();
        this.dialogRef.close('კატეგორია წარმატებით დაემატა');
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  editCategory() {
    this._loadingService.register();
    this._adminService.editCategory(this.category).subscribe(
      (res: PetitionCategory) => {
        this._loadingService.resolve();
        this.dialogRef.close('კატეგორია წარმატებით დარედაქტირდა');
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/categories-panel/dialogs/add-edit-category-dialog/add-edit-category-dialog.component.ts